import {
  fetchDynamicData,
  fetchFullData,
  fetchInitState,
} from 'actions/api-actions';
import { TOKEN_HEADER } from 'constants/headers';
import { HASH_NUMBER_SEARCH_PARAM } from 'constants/app-constants';
import { FETCH_DATA_TYPE } from 'constants/fetch-data';
import { getDefaultHeaders } from './headers';

const fetch = ({ type, dispatch, guid, hashNumber, headers }) => {
  switch (type) {
    case FETCH_DATA_TYPE.INIT:
      dispatch(fetchInitState(guid, { hashNumber }, headers));
      break;
    case FETCH_DATA_TYPE.FULL:
      dispatch(fetchFullData(guid, { hashNumber }, headers));
      break;
    case FETCH_DATA_TYPE.DYNAMIC:
      dispatch(fetchDynamicData(guid, { hashNumber }, headers));
      break;
    default:
      dispatch(fetchFullData(guid, { hashNumber }, headers));
      break;
  }
};

const fetchData = ({
  type,
  dispatch,
  inApp,
  guid,
  searchParams,
  getAccessToken,
}) => {
  const defaultHeaders = getDefaultHeaders();
  const hashNumber = searchParams.get(HASH_NUMBER_SEARCH_PARAM) || '';

  if (!inApp) {
    fetch({
      type,
      dispatch,
      guid,
      hashNumber,
      headers: defaultHeaders,
    });
    return;
  }

  getAccessToken().then(response => {
    const { result, isError: isNativeCallError } = response;
    const headers = isNativeCallError
      ? defaultHeaders
      : { ...defaultHeaders, [TOKEN_HEADER]: result };

    fetch({
      type,
      dispatch,
      guid,
      hashNumber,
      headers,
    });
  });
};

export default fetchData;
